module.exports = __webpack_public_path__ + "7e83e2e4c3c33fd76bbc587fe8ce6500.svg";